export default "__VITE_ASSET__MCLruX_Mp0YsKw8JknsdcQ__"